/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const AboutUsPage = () => (
  <Layout>
    <SEO title="About Us" />
    <h1>About Us</h1>
    <p>
      Preet Hospital, Bathinda came up in August 2007 as a dream project of Dr Manjit Singh Sidhu and Dr Preeti Sidhu to cater to the healthcare aspirations of women. It has emerged as a premier institution the region for the complete range of Healthcare needs of women. It is equipped with modern infrastructure, latest equipment and qualified staff to provide a wonderful experience while taking good care of the patient.
    </p>
    <h4>Our Hospital Facility</h4>
    <p>
      Preet Hospital is located on the 100 Feet Road in the Shant Nagar area. It is near to the District Secretariat, District Courts, Tehsil office and Bus Stand area.
    </p>
    <p>The hospital is a modern building with spacious, well ventilated and well demarcated patient areas.</p>
    <p>The OPD area is spacious and well segregated with ample and comfortable seating for the patients and the attendants.</p>
    <p>The indoor areas are spacious with natural light and ventilation in all rooms. The private rooms and wards are in separate areas.</p>
    <p>A surgical ICU and high risk pregnancy units is present for taking care of very sick and critical patients.</p>
    <p>The surgery areas and labour room are well segregated and equipped with state of the art equipment.</p>
    <p>There is facility of an in-house laboratory with all modern computerized equipment.</p>
    <p>There is an in-house chemist shop to provide for all medicines required for the patients.</p>
    <p>There is an in-house canteen for providing beverages and hot and healthy food for the patients and attendants.</p>
    <p>There is a basement parking for safe keeping of vehicles of the patients.</p>

    <h3>Our doctors</h3>
    <p><strong>Dr Manjit Singh Sidhu</strong> is a well qualified and highly experienced gynaecology surgeon. He did his MBBS and then MD in Gynaecology and Obstetrics from the premier institute of AFMC in Pune. After this he did his DNB (Diplomate National Board) from National Academy of Medical Sciences New Delhi and went on to become a Member of National Academy of Medical Sciences (MNAMS).</p>
    <p>He gained a wide experience in all aspects of Gynaecology and especially advanced gynaecological surgery working with highly experienced experts in the Army Medical Corps. He has worked in Armed Forces Medical College Pune, Command Hospital Pune, Command Hospital Calcutta, Command Hospital Lucknow, Base Hospital New Delhi and Command Hospital Chandigarh apart from other hospitals like Military Hospitals at Jodhpur, Ranchi (Namkum), Faizabad, Kota and Bathinda.</p>
    <p>He has expertise and a wide experience in the various aspects of Gynaecology and Obstetrics as under,</p>
    <ul>
      <li>Advanced Vaginal Surgery,</li>
      <li>Advanced Laparoscopic surgery,</li>
      <li>Advanced abdominal surgery for gynaecological disease,</li>
      <li>Advanced Hysteroscopic surgery,</li>
      <li>Urogynaecolgy,</li>
      <li>Gynaecological cancer surgery,</li>
      <li>Gynae Reconstructive and Cosmetic surgery,</li>
      <li>Infertility evaluation and management,</li>
      <li>High Risk Pregnancy care,</li>
      <li>Foetal Medicine and Foetal ultrasound.</li>
    </ul>
    <p><Link to={'/dr-manjit-singh-sidhu'}>(See More)</Link></p>

    <p sx={{ mt: 5 }}><strong>Dr Preeti Sidhu</strong> is well qualified and highly experienced as an Obstetrician and Gynaecologist. She did her MBBS from Patiala and her post graduation in Gynaecology from the renowned Armed Forces Medical College Pune. After this she has worked in a wide range of hospitals in Pune, Calcutta and Faizabad. She has a wide experience in dealing with all types of cases on her own as she has an experience of over two decades in private practice.</p>
    <p>She has expertise and a wide experience in obstetrics and gynaecology. Her areas of interest are</p>
    <ul>
      <li>Pregnancy care and especially complicated cases and high risk cases with a bad history,</li>
      <li>All types of delivery, simple or complicated,</li>
      <li>Surgery in all types of complicated obstetric cases,</li>
      <li>Gynaecologic cancer detection and prevention,</li>
      <li>Foetal and general ultrasound,</li>
      <li>Genetic counselling,</li>
      <li>Treatment of gynaecologic disease such as fibroids, polycystic ovaries, endometriosis,</li>
      <li>Infertility evaluation and management,</li>
      <li>MTP and contraception.</li>
    </ul>
    <p><Link to={'/dr-preeti-sidhu'}>(See More)</Link></p>
    <Link to="/">Go back to the homepage</Link>
  </Layout>
)

export default AboutUsPage
